import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { TextContent } from "../../../../../shared/TextContent/TextContent";
import { importMapping } from "../ImportMappingData";
import DynamicTable from "../../../../../shared/DynamicTable/DynamicTable";
import CustomBreadCrumbs from "../../../../../shared/BreadCrumbs/CustomBreadCrumbs";
import SideBarData from "../../../../Documentation/SideBar/SideBarData";

function ImportMappingDetails() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const urlValue = queryParams.get("value");
  const [importMappingData] = importMapping.table_data.filter(
    (data) => data.name.toLowerCase() === urlValue
  );
  const [valueNotFound, setValueNotFound] = useState(false);

  useEffect(() => {
    if (
      !urlValue ||
      !importMappingData[urlValue] ||
      !importMappingData[urlValue].subgroup.heading
    ) {
      setValueNotFound(false);
    }
  }, []);

  if (valueNotFound) {
    return "Value not found";
  }

  return (
    <section className="page-group" id="import-mapping-details">
      <CustomBreadCrumbs
                breadcrumbs={[`${SideBarData[4].subgroups[1]}`, `${importMappingData.name}`]} />
      <TextContent
        header={importMappingData.subgroup.heading}
        description={importMappingData.subgroup.description}
      />
      <div className="import-mapping">
        <DynamicTable
          title={importMappingData.subgroup.innerTable.header}
          columns={importMappingData.subgroup.innerTable.columns}
          data={importMappingData.subgroup.innerTable.data}
        />
      </div>

      <br />
    </section>
  );
}

export default ImportMappingDetails;
